export const ARR_TOOLTIP_TEXT =
  'ARR is a forward looking estimate based on fee schedule and AUM. If you have assets billed outside of Savvy there may be slight discrepancies in ARR shown here.';

export const ADVICE_ONLY_CLIENT_ARR_TOOLTIP_TEXT = 'ARR is estimated based on the advice only fee for this client.';

export const CO_CLIENT_EXPLANATION_TOOLTIP_TEXT =
  'Add a co-client if there are two members of the household. \
  The co-client will be able to onboard and sign documents via Savvy. \
  They will also get full access to the shared household portal on Savvy.';
